import { useEffect, useState } from 'preact/hooks';
import { useCloudpack } from './CloudpackProvider.js';
import { taskListSource, type TaskList } from '@ms-cloudpack/api-server/browser';

export const useTaskList = (): TaskList => {
  const cloudpack = useCloudpack();
  const [taskList, setTaskList] = useState<TaskList>({ tasks: [] });

  useEffect(() => {
    const subscription = cloudpack?.onDataChanged.subscribe(taskListSource, {
      onData: (data) => {
        setTaskList(data as TaskList);
      },
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [cloudpack]);

  return taskList;
};
